import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    ButtonGroup,
    StyledModal,
    ModalActions,
    Stack,
    Text,
} from 'sarsaparilla';

export default function ConfirmDeleteModal({ isOpen, onClose, onRemoveClick }) {
    if (!isOpen) {
        return null;
    }

    return (
        <StyledModal
            size="sm"
            shouldShowCloseButton={false}
            shouldActionsStickInMobile
            isOpen={isOpen}
            heading="Remove from cart?"
            onRequestClose={onClose}
        >
            <Stack>
                <Text>Are you sure you want to remove this item from your cart?</Text>
            </Stack>
            <ModalActions>
                <ButtonGroup isStretchedToFit>
                    <Button appearance="tertiary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button onClick={onRemoveClick}>Remove from Cart</Button>
                </ButtonGroup>
            </ModalActions>
        </StyledModal>
    );
}

ConfirmDeleteModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onRemoveClick: PropTypes.func,
};
